import React, { useEffect, useId, useState } from "react";
import { FiChevronDown } from "react-icons/fi";

export const useCompactLayout = () => {
  const [compact, setCompact] = useState(() => window.matchMedia?.("(max-width: 767px)").matches || false);
  useEffect(() => {
    const media = window.matchMedia?.("(max-width: 767px)");
    if (!media) return undefined;
    const update = () => setCompact(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  return compact;
};

const ResponsiveRows = ({ rows, getRowId, renderSummary, renderDetails, resetKey, children }) => {
  const compact = useCompactLayout();
  const prefix = useId();
  const [expanded, setExpanded] = useState(new Set());
  useEffect(() => { setExpanded(new Set()); }, [resetKey]);

  if (!compact || rows.length === 0) return children;

  return (
    <ul className="responsive-rows">
      {rows.map((row) => {
        const rowId = getRowId(row);
        const isExpanded = expanded.has(rowId);
        const detailsId = `${prefix}-${rowId}`;
        return (
          <li key={rowId}>
            <button
              type="button"
              className="responsive-row-toggle"
              aria-expanded={isExpanded}
              aria-controls={detailsId}
              onClick={() => setExpanded((current) => {
                const next = new Set(current);
                if (next.has(rowId)) next.delete(rowId);
                else next.add(rowId);
                return next;
              })}
            >
              <span className="responsive-row-summary">{renderSummary(row)}</span>
              <FiChevronDown aria-hidden="true" />
            </button>
            <div id={detailsId} className="responsive-row-details" hidden={!isExpanded}>
              {renderDetails(row)}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ResponsiveRows;